<template>
  <sea-page title="Gestione consulente" header="Gestione consulente">
    <v-card flat width="600" class="mx-auto">
      <form name="form" role="form" @submit.prevent="save()">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="$v.editedItem.codCliente.$model"
                  label="Codice cliente"
                  :error-messages="errors('codCliente')"
                  @input="$v.editedItem.codCliente.$touch()"
                  @blur="$v.editedItem.codCliente.$touch()"
                  maxlength="50"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  :items="distributions"
                  v-model="$v.editedItem.codDistribuzione.$model"
                  label="Distribuzione"
                  :error-messages="errors('codDistribuzione')"
                  @input="$v.editedItem.codDistribuzione.$touch()"
                  @blur="$v.editedItem.codDistribuzione.$touch()"
                  maxlength="50"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.numProdotto"
                  label="Numero Prodotto"
                  maxlength="50"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.host"
                  label="Host"
                  maxlength="50"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="$v.editedItem.login.$model"
                  label="Login"
                  maxlength="50"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="$v.editedItem.email.$model"
                  label="Email"
                  type="email"
                  :error-messages="errors('email')"
                  @input="$v.editedItem.email.$touch()"
                  @blur="$v.editedItem.email.$touch()"
                  maxlength="254"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="$v.editedItem.firstName.$model"
                  label="Nome"
                  :error-messages="errors('firstName')"
                  @input="$v.editedItem.firstName.$touch()"
                  @blur="$v.editedItem.firstName.$touch()"
                  maxlength="50"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="$v.editedItem.lastName.$model"
                  label="Cognome"
                  :error-messages="errors('lastName')"
                  @input="$v.editedItem.lastName.$touch()"
                  @blur="$v.editedItem.lastName.$touch()"
                  maxlength="50"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.codFiscale"
                  label="Codice Fiscale"
                  maxlength="16"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="editedItem.utentiAttivabili"
                  label="Utenti attivabili"
                  :error-messages="errors('utentiAttivabili')"
                  @input="$v.editedItem.utentiAttivabili.$touch()"
                  @blur="$v.editedItem.utentiAttivabili.$touch()"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel()"> Annulla </v-btn>
          <v-btn
            type="submit"
            color="blue darken-1"
            text
            :disabled="$v.editedItem.$invalid"
          >
            Salva
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import mixin from "@/mixin";
import { maxLength, required, email } from "vuelidate/lib/validators";
import { distributions } from "../../constants";

export default {
  mixins: [mixin, validationMixin, distributions],
  validations() {
    return {
      editedItem: {
        login: {},
        firstName: {
          maxLength: maxLength(50),
        },
        lastName: {
          required,
          maxLength: maxLength(50),
        },
        email: {
          required,
          maxLength: maxLength(254),
          email,
        },
        codCliente: {
          required,
          maxLength: maxLength(50),
        },
        codDistribuzione: {
          required,
          maxLength: maxLength(50),
        },
        utentiAttivabili: {
          required,
        },
      },
    };
  },
  beforeRouteEnter(to, _, next) {
    next((vm) => {
      if (to.params.id) {
        vm.fetchUser(to.params.id);
      } else {
        vm.resetCurrent();
      }
    });
  },
  data() {
    return { distributions };
  },
  methods: {
    ...mapActions({
      fetchUser: "users/fetchUser",
      resetCurrent: "users/resetCurrent",
      createUser: "users/createConsultant",
      updateUser: "users/updateUser",
    }),
    save() {
      this.$v.$touch();

      if (!this.$v.editedItem.$invalid) {
        if (this.editedItem.id) {
          this.updateUser(this.editedItem);
        } else {
          this.createUser(this.editedItem).then(() =>
            this.$router.push("/admin/consultants")
          );
        }
        // this.$router.push("/admin/consultants");
      }
    },
    cancel() {
      this.resetCurrent();
      this.$router.back();
    },
    errors(fieldName) {
      const errors = [];
      if (!this.$v.editedItem[fieldName].$dirty) return errors;
      if (fieldName === "firstName") {
        !this.$v.editedItem.firstName.maxLength &&
          errors.push(this.locales.maxLength(50));
      } else if (fieldName === "lastName") {
        !this.$v.editedItem.lastName.required &&
          errors.push(this.locales.required);
        !this.$v.editedItem.lastName.maxLength &&
          errors.push(this.locales.maxLength(50));
      } else if (fieldName === "email") {
        !this.$v.editedItem.email.required &&
          errors.push(this.locales.required);
        !this.$v.editedItem.email.maxLength &&
          errors.push(this.locales.maxLength(254));
        !this.$v.editedItem.email.email && errors.push(this.locales.email);
      } else if (fieldName === "codCliente") {
        !this.$v.editedItem.codCliente.required &&
          errors.push(this.locales.required);
        !this.$v.editedItem.codCliente.maxLength &&
          errors.push(this.locales.maxLength(50));
      } else if (fieldName === "codDistribuzione") {
        !this.$v.editedItem.codDistribuzione.required &&
          errors.push(this.locales.required);
        !this.$v.editedItem.codDistribuzione.maxLength &&
          errors.push(this.locales.maxLength(50));
      } else if (fieldName === "codFiscale") {
        this.isCodFiscaleRquired &&
          !this.$v.editedItem.codFiscale.maxLength &&
          errors.push(this.locales.maxLength(15));
      } else if (fieldName === "utentiAttivabili") {
        !this.$v.editedItem.utentiAttivabili.required &&
          errors.push(this.locales.required);
      }
      return errors;
    },
  },
  computed: {
    ...mapGetters({ editedItem: "users/current" }),
  },
};
</script>

<style>
</style>
